/* WRLD TAGS pin bundle, part 1 of 2: the zoom lightbox.
   Part 2 (wt-pin-bundle-b.js) defines the module and uses this.
   Load order matters: this file first. */
(function () {
  'use strict';
  if (window.WTPinLightbox) return;

  class WTPinLightbox {
    constructor(opts) {
      this.pins = opts.pins;
      this.money = opts.money;
      this.isPicked = opts.isPicked;
      this.onToggle = opts.onToggle;
      this.index = null;
      this.build();
    }

    build() {
      const self = this;
      const el = document.createElement('div');
      el.className = 'wtb-lb';
      el.setAttribute('role', 'dialog');
      el.setAttribute('aria-modal', 'true');
      el.setAttribute('aria-label', 'Pin detail');
      el.innerHTML =
        '<button type="button" class="wtb-lb__scrim" data-c aria-label="Close"></button>' +
        '<div class="wtb-lb__panel">' +
          '<span class="wtb-lb__count" data-n></span>' +
          '<button type="button" class="wtb-lb__close" data-c aria-label="Close">✕</button>' +
          '<button type="button" class="wtb-lb__nav wtb-lb__nav--prev" data-p aria-label="Previous pin">' +
            '<svg viewBox="0 0 10 10"><path d="M6.5 1L2.5 5l4 4"/></svg></button>' +
          '<button type="button" class="wtb-lb__nav wtb-lb__nav--next" data-x aria-label="Next pin">' +
            '<svg viewBox="0 0 10 10"><path d="M3.5 1l4 4-4 4"/></svg></button>' +
          '<div class="wtb-lb__stage" data-s>' +
            '<img data-i alt="">' +
            '<span class="wtb-lb__hint" data-h>Click to zoom</span>' +
          '</div>' +
          '<div class="wtb-lb__meta">' +
            '<span class="n" data-t></span><span class="p" data-pr></span>' +
            '<button type="button" class="wtb-lb__add" data-a>Add to bundle</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(el);
      this.el = el;
      this.stage = el.querySelector('[data-s]');
      this.img = el.querySelector('[data-i]');
      this.addBtn = el.querySelector('[data-a]');

      el.querySelectorAll('[data-c]').forEach(function (b) {
        b.addEventListener('click', function () { self.close(); });
      });
      el.querySelector('[data-p]').addEventListener('click', function () { self.show(self.index - 1); });
      el.querySelector('[data-x]').addEventListener('click', function () { self.show(self.index + 1); });
      this.addBtn.addEventListener('click', function () { self.onToggle(self.index); });

      this.stage.addEventListener('click', function (e) {
        if (self.stage.classList.contains('is-zoomed')) { self.unzoom(); return; }
        const r = self.stage.getBoundingClientRect();
        self.img.style.transformOrigin =
          ((e.clientX - r.left) / r.width) * 100 + '% ' + ((e.clientY - r.top) / r.height) * 100 + '%';
        self.stage.classList.add('is-zoomed');
        el.querySelector('[data-h]').textContent = 'Click to zoom out';
      });

      document.addEventListener('keydown', function (e) {
        if (!el.classList.contains('is-open')) return;
        if (e.key === 'Escape') self.close();
        if (e.key === 'ArrowLeft') self.show(self.index - 1);
        if (e.key === 'ArrowRight') self.show(self.index + 1);
      });
    }

    unzoom() {
      this.stage.classList.remove('is-zoomed');
      this.img.style.transformOrigin = 'center center';
      this.el.querySelector('[data-h]').textContent = 'Click to zoom';
    }

    paintButton() {
      const pin = this.pins[this.index];
      if (!pin) return;
      if (!pin.avail) {
        this.addBtn.textContent = 'Sold out';
        this.addBtn.disabled = true;
        return;
      }
      this.addBtn.disabled = false;
      const on = this.isPicked(this.index);
      this.addBtn.textContent = on ? 'Remove from bundle' : 'Add to bundle';
      this.addBtn.classList.toggle('is-on', on);
    }

    /* Sept 11 2026 (Jaime: "a smoother effect when it opens"): the photo crossfades when the pin changes
       while the lightbox is already open; on open it is set directly so the panel animates with the
       photo in place. The text and button update at once, the swap waits for the short fade-out. */
    show(i) {
      const self = this;
      const n = this.pins.length;
      this.index = ((i % n) + n) % n;
      const pin = this.pins[this.index];
      const swap = function () { self.img.src = pin.zoom; self.img.alt = pin.title; };
      if (this.el.classList.contains('is-open') && this.img.src && this.img.src !== pin.zoom) {
        this.img.classList.add('is-swapping');
        clearTimeout(this.swapTimer);
        this.swapTimer = setTimeout(function () {
          const done = function () { self.img.classList.remove('is-swapping'); };
          self.img.addEventListener('load', done, { once: true });
          self.img.addEventListener('error', done, { once: true });
          swap();
          if (self.img.complete) done();
        }, 150);
      } else {
        this.img.classList.remove('is-swapping');
        swap();
      }
      this.el.querySelector('[data-t]').textContent = pin.title;
      this.el.querySelector('[data-pr]').textContent = this.money(pin.price);
      this.el.querySelector('[data-n]').textContent = (this.index + 1) + ' of ' + n;
      this.unzoom();
      this.paintButton();
    }

    /* open: display it, then on the next frame add is-in so the scrim fades and the panel settles in
       (CSS transitions need a painted starting state). close: play it in reverse (is-out) and hide
       after the transition. The 260ms matches the longest transition in wt-pin-bundle-b.css. */
    open(i) {
      const self = this;
      clearTimeout(this.hideTimer);
      this.el.classList.remove('is-out');
      this.show(i);
      this.el.classList.add('is-open');
      this.prevFocus = document.activeElement;
      document.body.style.overflow = 'hidden';
      void this.el.offsetWidth;
      /* arm on the next painted frame; the timer is a fallback for when frames are paused (background tab) */
      const arm = function () { self.el.classList.add('is-in'); };
      requestAnimationFrame(function () { requestAnimationFrame(arm); });
      setTimeout(arm, 50);
      this.addBtn.focus();
    }

    close() {
      const self = this;
      if (!this.el.classList.contains('is-open')) return;
      this.el.classList.remove('is-in');
      this.el.classList.add('is-out');
      document.body.style.overflow = '';
      this.index = null;
      if (this.prevFocus && this.prevFocus.focus) this.prevFocus.focus();
      clearTimeout(this.hideTimer);
      this.hideTimer = setTimeout(function () {
        self.el.classList.remove('is-open', 'is-out');
        self.img.classList.remove('is-swapping');
      }, 260);
    }
  }

  window.WTPinLightbox = WTPinLightbox;
})();
